import React from 'react';

import { JiraLink } from '../components/JiraLink';
import { isReadyToImport } from '../handlers/jira/unmatchedWorklogs';
import UnmatchedWorklogFields from './unmatchedWorklogRow/UnmatchedWorklogFields';

export default function UnmatchedWorklogRow({ e, i }) {
  const canInclude = isReadyToImport(e);
  return (
    <div className="py-[8px] px-[12px] [border-bottom:0.5px_solid_#f0eeeb] bg-[#fffbf0]">
      <div className="text-[11px] text-[#92600A] mb-[2px]">
        {e.reason?.replace(/ : null$/, ' : ticket sans epic')}
        {e.issueKey ? (
          <>
            {' '}
            · <JiraLink ticket={e.issueKey} style={{ fontSize: 11, color: '#92600A' }} />
          </>
        ) : (
          ''
        )}
      </div>
      <div className="text-[10px] text-grey-light mb-[5px]">
        {e.date} · {Math.round(e.hours * 10) / 10}h · {e.month}
      </div>
      <UnmatchedWorklogFields canInclude={canInclude} e={e} i={i} />
    </div>
  );
}
